import { truncateText } from "@similarweb/styles";
import { ChipItemBasicWrapper, ChipItemWrapper } from "@similarweb/ui-components";
import styled from "styled-components";

export const StyledItemWithSeparator = styled.div`
    align-items: center;
    display: flex;
`;

export const StyledContainer = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;

    ${ChipItemWrapper} {
        max-width: 100%;

        div {
            ${truncateText()}
        }
    }

    ${ChipItemBasicWrapper} {
        max-width: 100%;
    }
`;

export const StyledLoaderWrapper = styled.div`
    height: 32px;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 15px;
`;
